import React, { useState } from 'react';
import { ReactP5Wrapper } from "@p5-wrapper/react";

function sketch(p5) {
  let emojiSize = 100;
  let accessorySizeFactor = 0.8;
  let emoji = "😀";
  let accessoryEmoji = "";
  let isLoading = false;
  let bgColor = '#fbd043';

  // Define a mapping between letters and accessory emojis
  const letterToAccessory = {
    'a': "🫰",
    'b': "✋",
    'd': "💫",
    'e': "🍑",
    'f': "🫶",
    'g': "👎",
    'h': "✌️",
    'i': "💅",
    'j': "🤞",
    'k': "🤜",
    'l': "💨",
    'm': "🙏",
    'n': "🤏",
    'o': "🖕",
    'p': "🤘",
    'q': "👍",
    'r': "💪",
    's': "👐",
    't': "🤙",
    'u': "🖖",
    'v': "👊",
    'w': "🤌",
    'x': "🕳️",
    'y': "🫵",
    'z': "🤌",
    'c': "👏",
  };

  // Define the four background colors
  const backgroundColors = [
    "#67399B", // Purple
    "#E43B40", // Blue
    "#F87124", // Orange
    "#48B6CD"  // Teal
  ];

  // States for color and inputEntered
  let color = "#ffffff";
  let inputEntered = false;
  let inputText = ""; // Define inputText variable

  p5.updateWithProps = (props) => {
    color = props.circleColor; // Update color from props
    inputEntered = props.inputEntered;
    inputText = props.inputText;
    bgColor = props.bgColor; // Update inputText from props
  };

  p5.setup = () => {
    p5.createCanvas(600, 600);
    p5.textSize(32);
    p5.textAlign(p5.CENTER, p5.CENTER);
    p5.background(220); // Initial background for p5.js sketch
  };

  p5.draw = () => {
    if (!inputEntered) {
      displayLoadingAnimation();
    } else {
      displayEmojisAndBackground();
    }
  };

  function generateEmoji() {
    isLoading = true;

    setTimeout(() => {
      isLoading = false;

      let sumASCII = 0;
      for (let i = 0; i < inputText.length; i++) {
        sumASCII += inputText.charCodeAt(i);
      }

      const emojiMap = [
        "😀", "😁", "🙃", "😃", "😄", "🥺", "😆", "😇", "😈", "😉",
        "😊", "😋", "🫠", "😎", "😏", "😐", "😑", "😒", "🧐", "😔",
        "😕", "😖", "😗", "🤯", "🤑", "🤧", "😛", "😜", "😝", "😞",
        "😟", "🤪", "😡", "😢", "😣", "😤", "😥", "😦", "😧", "😨",
        "😩", "😪", "😫", "😬", "😭", "😮", "😯", "😰", "😱", "😲",
        "😳", "😴", "🤓", "😶", "😷", "🤬", "🤤", "🤤", "🥶", "🤠",
      ];

      const index = sumASCII % emojiMap.length;
      emoji = emojiMap[index];

      const firstLetter = inputText.charAt(0).toLowerCase();
      accessoryEmoji = letterToAccessory[firstLetter] || "";

      inputEntered = true;
    }, 1000);
  }

  function displayLoadingAnimation() {
    p5.fill('#000000');
    p5.textSize(44);
    p5.text("Find your nameoji!", p5.width / 2, p5.height / 2 - 8);
    p5.textSize(44);
    p5.text("⠋", p5.width / 2, p5.height / 2 + 30);
  }

  function displayEmojisAndBackground() {
    let sumASCII = 0;
    for (let i = 0; i < inputText.length; i++) {
      sumASCII += inputText.charCodeAt(i);
    }

    const bgColor = backgroundColors[sumASCII % 4];

    p5.background(bgColor);

    p5.textSize(emojiSize);
    p5.fill(color); // Use the updated color
    p5.text(emoji, p5.width / 2, p5.height / 2 - emojiSize / 4);
    p5.textSize(emojiSize * accessorySizeFactor);
    p5.text(accessoryEmoji, p5.width / 2, p5.height / 2 + emojiSize / 3);
  }

  p5.keyPressed = () => {
    if (p5.keyCode === p5.ENTER) {
      generateEmoji();
    }
  };
}

function App() {
  const [color, setColor] = useState('#fbd043');
  const [inputEntered, setInputEntered] = useState(false);
  const [inputText, setInputText] = useState("");
  const [key, setKey] = useState(Math.random());
  const [colour, setColour] = useState('#fbd043');

  const handleInputChange = (e) => {
    setInputText(e.target.value);
  };

  const handleColorChange = (newColor) => {
    setColor(newColor.hex);
  };

  const generateEmoji = () => {
    setInputEntered(true);

    setTimeout(() => {
      setInputEntered(false);
      setInputText("");
      setColor('#ffffff');
      setKey(Math.random());
    }, 1000);
  };

  return (
    <div className="min-h-screen flex flex-row items-center justify-center bg-cover bg-center bg-fixed " style={{ backgroundImage: 'url(https://www.creativeboom.com/uploads/articles/c6/c65ee317801e545f56fd14bbff2faaece658dd2a_1620.png)', }}>
      <div className="bg-white bg-opacity-75 p-8 rounded-lg text-center">
        <input
          type="text"
          placeholder="What's Your Name"
          value={inputText}
          onChange={handleInputChange}
          className="text-1xl px-4 py-2 mr-2"
        />
        <div className="bg-opacity-50 p-2 ml-2">Press Enter</div>
       
        <button
          className="bg-gradient-to-r from-blue-400 to-green-400 hover:from-pink-500 hover:to-yellow-500 px-6 py-4 text-white text-1xl rounded mt-2 transition duration-300"
          onClick={generateEmoji}
        >
          Regenerate
        </button>
      </div>
      <ReactP5Wrapper
        sketch={sketch}
        circleColor={color}
        inputEntered={inputEntered}
        inputText={inputText}
        key={key}
        bgColor={colour}
      />
    </div>
  );
}

export default App;
